import { blue, brown, green, indigo, orange, pink, purple, teal } from '@mui/material/colors'

export const DEFAULT_BOUNDARY_COLOR = blue[700]

// Positional palette — boundary i gets PALETTE[i % length]. Colors are display-only
// (not persisted); the wire format carries only geometry + names.
export const BOUNDARY_COLOR_PALETTE = [
  DEFAULT_BOUNDARY_COLOR,
  green[600],
  orange[800],
  purple[500],
  teal[600],
  pink[500],
  indigo[500],
  brown[500],
]

export const BOUNDARY_SOURCE_ID = 'zone-boundaries'
export const BOUNDARY_FILL_LAYER_ID = 'zone-boundaries-fill'
export const BOUNDARY_LINE_LAYER_ID = 'zone-boundaries-line'
export const BOUNDARY_LABEL_SOURCE_ID = 'zone-boundary-labels'
export const BOUNDARY_LABEL_LAYER_ID = 'zone-boundary-labels-symbol'

export const BOUNDARY_MAP_MODES = {
  VIEW: 'view',
  EDIT: 'edit',
  DRAW: 'draw',
} as const

export type BoundaryMapMode = typeof BOUNDARY_MAP_MODES[keyof typeof BOUNDARY_MAP_MODES]
